"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var AB_Test = /** @class */ (function () {
    function AB_Test(experiments, storageAdapter) {
        var _this = this;
        this.forceRefresh = true;
        this.queryPart = {};
        this.storageAdapter = storageAdapter;
        experiments.forEach(function (experiment) {
            var selectedVariant;
            var restoredVariant = _this.storageAdapter.restoreExperimentVariant(experiment.name);
            if (restoredVariant === null ||
                !experiment.variants.find(function (variant) { return variant.name == restoredVariant.name; })) {
                selectedVariant = _this.selectVariant(experiment.variants);
            }
            else {
                selectedVariant = restoredVariant;
            }
            var saveVariant = {
                experimentName: experiment.name,
                variant: selectedVariant
            };
            _this.storageAdapter.addExperimentVariant(saveVariant);
            if (experiment.resolve && typeof experiment.resolve == "function") {
                experiment.resolve(saveVariant);
            }
        });
        this.setQueryPart();
    }
    AB_Test.prototype.setQueryPart = function () {
        var _this = this;
        if (Array.isArray(this.storageAdapter.selectedVariantsMap)) {
            this.storageAdapter.selectedVariantsMap.forEach(function (v) {
                if (v.variant.name == 'Default') {
                    _this.queryPart[v.experimentName] = undefined;
                }
                else {
                    _this.queryPart[v.experimentName] = v.variant.name;
                }
            });
        }
    };
    // Выбор варианта
    AB_Test.prototype.selectVariant = function (variants) {
        variants.sort(function (a, b) { return a.weight - b.weight; });
        var selectedVariant = this.weightedRandom(variants, variants.map(function (v) { return v.weight; }));
        return selectedVariant;
    };
    // Рандомный выбор по весу
    AB_Test.prototype.weightedRandom = function (values, weights) {
        var totalWeight = weights.reduce(function (prev, cur) {
            return prev + cur;
        }, 0);
        var rnd = Math.random() * totalWeight;
        var n = 0;
        for (var i = 0; i < values.length; i++) {
            n += weights[i];
            if (n >= rnd) {
                return values[i];
            }
        }
    };
    // Получение варинта по имени эксперимента
    AB_Test.prototype.getVariant = function (experimentName) {
        // TODO maybe select first in list variants, or append <VariantDefault>
        if (!experimentName) {
            experimentName = "Default";
        }
        var selectedVariant = this.storageAdapter.getVariant(experimentName);
        return selectedVariant;
    };
    return AB_Test;
}());
exports.AB_Test = AB_Test;
//# sourceMappingURL=AB_Test.js.map